import { MultiSelectItem, Platba } from '@/main/store/@types/dropdown.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { DEFAULT, ERROR, UPDATE_BASIC_EDIT } from '@/main/store/listEditTypes';

import { NAME as name, CRUMB_LABEL_KEY, PlatbaTyp, TypPrijemceFaktury, DokladNaplnFakturaci, IPartialInvoice } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	DealershipText: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	MatfirmId: null as number | null,
	MatfirmIdText: null as string | null,
	PojistovnaIdText: null as string | null,
	PojistovnaId: null as number | null,
	JinyPrijemceId: null as number | null,
	JinyPrijemceIdText: null as string | null,
	LeaszakaznikId: null as number | null,
	LeaszakaznikIdText: null as string | null,
	DuzpDate: null as Date | null,
	SplatnostDate: null as Date | null,
	SplatnostDoba: null as number | null,
	PlatbaPzn: null as PlatbaTyp | null,
	EguiPaymentMethod: null as PlatbaTyp | null,
	PaymentMethods: [] as any[],
	PlatbaListItem: [] as number[],
	Remark: null as string | null,
	MenaId2: null as number | null,
	PokladnaId: null as number | null,
	BankovniSpojeni1: null as number | null,
	BankovniSpojeni2: null as number | null,
	DphSzbOzn: null as number | null,
	ReklamniTextId: null as number | null,
	ReklamniTextIdText: null as string | null,
	ZakazkaId: 0 as number,
	ZakazkaZalohaId: null as number | null,
	PovId: null as number | null,
	PovZalohaId: null as number | null,
	DokladId: null as number | null,
	DokladDruh: null as string | null,
	DokladNaplnFakturaci: null as DokladNaplnFakturaci | null,
	FakturaceSubject: null as TypPrijemceFaktury | null,
	HasPermissionVecneKonto: null as boolean | null,
	IsOprava: null as boolean | null,
	HasPermissionSplatnost: null as boolean | null,
	DefaultBankUcetId: null as number | null,
	PrimarniMenaOrganizace: null as number | null,
	UzivatelDefaultPokladnaId: null as number | null,
	HasPermissionDuzpDpp: null as boolean | null,
	BillingPrp: null as boolean | null,
	LeaszakaznikSplatnostDoba: null as number | null,
	JinyPrijemceSplatnostDoba: null as number | null,
	PojistovnaSplatnostDoba: null as number | null,
	LeaszakaznikPlatbaPzn: null as number | null,
	JinyPrijemcePlatbaPzn: null as number | null,
	PojistovnaPlatbaPzn: null as number | null,
	ZakaznikSplatnostDoba: null as number | null,
	ZakaznikPlatbaPzn: null as number | null,
	DobropduvodHtml: null as string | null,
	DobropisVrubopisDTOs: null as [] | null,
	PlatbaLimitConfirmed: false as boolean,
	Text2ddOv: null as string | null,
	DphrozpadPrp: false,
	DphrozpadPrpEnabled: false,
	AdvanceAmount: null as number | null,
	InvoicePartTotal: null as number | null,
	InvoiceLaborTotal: null as number | null,
	InvoiceTotalAmount: null as number | null,
	
	DPHandlingFee: 0 as number,
	RemarkDPHandlingFee: null as string | null,
	DPDealerDeduction: 0 as number,
	RemarkDPDealerDeduction: null as string | null,
	DPOEMDeduction: 0 as number,
	RemarkDPOEMDeduction: null as string | null,
	DPRoundOff: 0 as number,
	RemarkDPRoundOff: null as string | null,	

	PaymentPartTotal: null as number | null,
	PaymentLaborTotal: null as number | null,
	PaymentAdvancePayment: null as number | null,
	PaymentTotalAmount: null as number | null,
	OrderSubtypeId: null as number | null,
	ReasonId: null as string | null,
	Remarks: null as string | null,
	IsProformaCreated: false as boolean,
	ZakazkaStav: null as number | null,
	CustomerSplit: [] as IPartialInvoice[],
	OEMSplit: [] as IPartialInvoice[],
	DealershipSplit: null as IPartialInvoice | null,
	OrderType: null as string | null,
	PartialInvoices: [] as IPartialInvoice[] | null,
	EGUIInvoiceNumber: null as string | null,
	// eGUIIssueInvoiceRequestDTO: {},
	Donation: null as string | null,
	LoveCode: null as string | null,
	CarrierType: null as string | null,
	CarrierNum: null as string | null,
	IsGUIEnabled: false as boolean,
	VehicleId: null as number | null,
	CancelInvoicedNo: null as string | null,
	EguiSelectedPaymentMethod: null as PlatbaTyp | null,
	EGUISelectedInvoiceNumber: null as string | null,
	InvoiceRemark: null as string | null,
	CustomerIdentifier: null as string | null,
	CustomerName: null as string | null,
	IsItemSeparated: null as string | null,
	EguiTypes: null as number | null,
	EguiTransDisplayOptions: null as number | null,
	EguiMultiSelectTypes: [] as MultiSelectItem[],
	CashAmount: 0 as number,
	CreditAmount: 0 as number,
	DebitAmount: 0 as number,
	OnlineAmount: 0 as number,
	CashPaymentAmount: 0 as number,
	RemarkCashPaymentAmount: null as string | null,
	CreditPaymentAmount: 0 as number,
	RemarkCreditPaymentAmount: null as string | null,
	DebitPaymentAmount: 0 as number,
	RemarkDebitPaymentAmount: null as string | null,
	OnlinePaymentAmount: 0 as number,
	RemarkOnlinePaymentAmount: null as string | null,
	AccountReceivableAmount: 0 as number,
	RemarkAccountReceivableAmount: null as string | null,
	TTPaymentAmount: 0 as number,
	RemarkTTPaymentAmount: null as string | null,
	ObjPaymentDetails: [] as IPartialInvoice[],
	ObjeGUISplitDetails: [] as any[],
	IsPartIssueConfirmed: false as boolean,
	EguiTypesSecond: null as number | null,
	CustomerIdentifierSecond: null as string | null,
	CustomerNameSecond: null as string | null,
	EguiTransDisplayOptionsSecond: null as number | null,
	InvoiceRemarkSecond: null as string | null,
	EGUIDefaultRemarks: '' as string,
};

const dropdownList = {
	EguiPaymentMethods: [],
	BankovniSpojeni1: [],
	BankovniSpojeni2: [],
	DphSzbOzn: [],
	OsdataPzn: [],
	PlatbaPzn: [] as Platba[],
	MenaId2: [],
	PokladnaId: [],
	RejectedReasons: [],
	EguiTypes: [],
	EguiTransDisplayOptions: [],
	EguiMultiSelectTypes: [],
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	localState: {
		OldDuzpDate: null as null | Date,
		nahled: true,
		showTiskDialog: false,
		htmlText2: '',
		isAllPartiesSelected: false,
		isIndeterminate: false,
		unbilledSplitPartiesCount: 0,
		combinedSplitParties: [] as IPartialInvoice[],
		isBillingScreen: false
	},
	depTableNames: [],
	depTableSettings: {},
	extraActions: {
		async [DEFAULT]({ commit, dispatch, state }, servicePromise: Promise<any>) {
			try {
				const resp = await servicePromise;

				commit(UPDATE_BASIC_EDIT, { data: resp.data });

				state.localState.OldDuzpDate = new Date(resp.data.DuzpDate);

				return resp;
			} catch (err) {
				dispatch(ERROR, { objectName: state.name, err }, { root: true });
				return err;
			}
		},
	},
	extraMutations: {
		[editMutations.FAKTURACE_POJISTOVNA_SELECT_MAPPER](state, { data }: { data: any }) {
			state.edit.FakturaceSubject = TypPrijemceFaktury.POISTOVNA;
			state.edit.PojistovnaId = data.value;
			state.edit.PojistovnaIdText = data.text;
			state.edit.PojistovnaSplatnostDoba = data.splatnost;
			state.edit.PojistovnaPlatbaPzn = data.platbaPzn;
			state.edit.PlatbaPzn = data.platbaPzn;
			state.edit.SplatnostDoba = data.splatnost;
			state.edit.EguiPaymentMethod = data.eguiPaymentMethod;
		},
		[editMutations.FAKTURACE_JINY_PRIJEMCE_SELECT_MAPPER](state, { data }: { data: any }) {
			state.edit.FakturaceSubject = TypPrijemceFaktury.JINY_PRIJEMCE;
			state.edit.JinyPrijemceId = data.value;
			state.edit.JinyPrijemceIdText = data.text;
			state.edit.JinyPrijemceSplatnostDoba = data.splatnost;
			state.edit.JinyPrijemcePlatbaPzn = data.platbaPzn;
			state.edit.PlatbaPzn = data.platbaPzn;
			state.edit.SplatnostDoba = data.splatnost;
			state.edit.EguiPaymentMethod = data.eguiPaymentMethod;
		},
		[editMutations.FAKTURACE_LEAS_ZAKAZNIK_SELECT_MAPPER](state, { data }: { data: any }) {
			state.edit.FakturaceSubject = TypPrijemceFaktury.LEASING;
			state.edit.LeaszakaznikId = data.value;
			state.edit.LeaszakaznikIdText = data.text;
			state.edit.LeaszakaznikSplatnostDoba = data.splatnost;
			state.edit.LeaszakaznikPlatbaPzn = data.platbaPzn;
			state.edit.PlatbaPzn = data.platbaPzn;
			state.edit.SplatnostDoba = data.splatnost;
			state.edit.EguiPaymentMethod = data.eguiPaymentMethod;
		},
	},
	extraGetters: {},
	props: {
		mode: null,
		filter: {
			dokladId: null as number | null,
			zakazkaId: null as number | null,
			zakazkaZalohaId: null as number | null,
			povId: null as number | null,
			povZalohaId: null as number | null,
			dokladNaplnFakturaci: null as DokladNaplnFakturaci | null,
			dobropisVrubopisDTOs: null as [] | null,
			isapprover: null as boolean | null,
			rrId: null as number | null,
			statusId: null as number | null,
			orderType: null as string | null,
			createdById: null as number | null,
			CRNo: null as string | null,
			zakazkaDTO: null as any | null,
			isProforma: false as boolean | false,
			isBillingScreen :  false as boolean | false
		},
	},
});
